import { durations, easings, delays } from '../../constants';
import { mq, mqH, mqLandscape } from '../../utils/mediaQuery';
import { colors } from '../../constants';

export const viewDetailsContainer = {
  padding: '0 40px',
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  willChange: 'opacity',
  transition: `opacity ${durations.viewDetailsDuration}ms ${easings.viewDetailsOpacity} ${durations.viewDetailsDuration}ms`,
};

export const sceneStyling = {
  display: 'flex',
  justifyContent: 'space-between',
  height: 300,
  width: '100%',
  maxWidth: 166,
  margin: 'auto auto 152px auto',
  transition: `opacity ${durations.viewDetailsDuration}ms ${easings.viewDetailsOpacity}`,
  [`${mqLandscape}`]: {
    margin: 'auto auto 80px auto',
    height: 200,
  },
  [`${mq('sm')} and ${mqH('xs')}`]: {
    margin: 'auto auto 85px auto',
    height: 230,
    maxWidth: 166,
  },
  [mq('md')]: {
    margin: 'auto auto 100px auto',
    maxWidth: 276,
  },
};

export const averageStyling = (average) => {
  return {
    position: 'absolute',
    zIndex: -1,
    left: 0,
    bottom: 0,
    margin: 'auto auto 152px auto',
    paddingLeft: '20px',
    paddingRight: '20px',
    width: '100%',
    height: average,
    lineHeight: 1.33,
    color: colors.white,
    transition: `opacity ${durations.viewDetailsDuration}ms ${easings.viewDetailsOpacity}`,
    [`${mqLandscape}`]: {
      margin: 'auto auto 80px auto',
    },
    [`${mq('sm')} and ${mqH('xs')}`]: {
      margin: 'auto auto 85px auto',
    },
    [mq('md')]: {
      margin: 'auto auto 100px auto',
    },
  };
};

export const averageWrapperStyling = (isAnimate) => {
  return {
    position: 'relative',
    display: 'flex',
    fontWeight: 500,
    fontSize: '12px',

    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      margin: '0 auto',
      borderTop: `1px solid ${colors.grey2}`,
      width: isAnimate ? '100%' : 0,
      transition: `width ${durations.viewDetailsDuration}ms ${
        easings.viewDetailsOpacity
      } ${!isAnimate ? 0 : delays.revealAnimation * 2}ms`,
    },

    span: {
      float: 'left',
      marginTop: '-8px',
      padding: '0 0 0 12px',
      backgroundColor: colors.black,
      zIndex: 0,

      '&:first-of-type': {
        marginRight: 'auto',
        padding: '0 12px 0 0',
      },
    },
  };
};

export const h3 = (isAnimate) => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: `${275 + 25}px !important`,
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: '-30px',
    margin: '0 auto',
    padding: 0,
    fontSize: '12px !important',
    lineHeight: '16px !important',
    transition: `opacity ${durations.viewDetailsDuration}ms ${easings.viewDetailsOpacity}`,
    opacity: isAnimate ? 1 : 0,

    span: {
      display: 'block',
      width: '100%',
      maxWidth: '50px',
      textAlign: 'center',
    },

    [mq('md')]: {
      maxWidth: `${276 + 24}px`,
    },
  };
};

export const leftBarAnimation = (isAnimate) => {
  return {
    opacity: isAnimate ? 1 : 0,
    transform: isAnimate ? 'translateX(0);' : 'translateX(69px);',
    transition: `
      transform ${durations.scalePillarDuration}ms ${easings.pillarScale},
      opacity ${durations.scalePillarDuration}ms ${easings.pillarScale}
    `,
    [mq('md')]: {
      transform: isAnimate ? 'translateX(0);' : 'translateX(124px);',
    },
  };
};

export const rightBarAnimation = (isAnimate) => {
  return {
    opacity: isAnimate ? 1 : 0,
    transform: isAnimate ? 'translateX(0);' : 'translateX(-69px);',
    transition: `
      transform ${durations.scalePillarDuration}ms ${easings.pillarScale},
      opacity ${durations.scalePillarDuration}ms ${easings.pillarScale}
    `,
    [mq('md')]: {
      transform: isAnimate ? 'translateX(0);' : 'translateX(-124px);',
    },
  };
};

// export const serviceTitleBackButton = {
//   display: 'flex',
//   position: 'absolute',
//   top: 20,
//   left: 40,
//   willChange: 'opacity',
//   transition: `opacity ${durations.viewDetailsDuration}ms ${easings.viewDetailsOpacity}`,
//   zIndex: 5,
//   span: {
//     width: '60%',
//     position: 'relative',
//     display: 'inline-block',
//     textAlign: 'left',
//   },
//   svg: {
//     marginRight: 10,
//     position: 'absolute',
//     top: 5,
//     transform: `translateX(calc(-100% - 10px))`,
//   },
// };

// export const rowContainer = (lastRow) => {
//   return {
//     display: 'flex',
//     position: 'relative',
//     justifyContent: 'center',
//     alignItems: 'flex-end',
//     width: '100%',
//     borderBottom: '1px solid #393939',
//     paddingTop: lastRow ? 30 : 20,
//     [`${mqLandscape}`]: {
//       paddingTop: 8,
//     },
//     [`${mq('sm')} and ${mqH('xs')}`]: {
//       paddingTop: 10,
//     },
//     [mq('lg')]: {
//       paddingTop: 20,
//     },
//   };
// };

// export const rowTitle = {
//   fontSize: '10px',
//   position: 'absolute',
//   left: 0,
//   bottom: '10px',
//   maxWidth: '60px',
//   fontWeight: 500,
//   color: colors.grey,
//   [`${mqLandscape}`]: {
//     maxWidth: '85px',
//   },
//   [mq('sm')]: {
//     maxWidth: '85px',
//   },
// };

// export const detailsRowLabels = {
//   fontSize: '10px',
//   color: colors.white,
//   marginTop: '10px',
//   display: 'flex',
//   width: '100%',
//   justifyContent: 'center',
//   [`${mqLandscape}`]: {
//     display: 'none',
//   },
//   [mq('sm')]: {
//     display: 'none',
//   },
// };
